/* eslint-disable import/prefer-default-export */

export const HELLO_WORLD_NAME_UPDATE = "HELLO_WORLD_NAME_UPDATE";
